import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import UserAvatar from "../../../common/avatar/UserAvatar";
import configuration from "../../../config/Config";

export function PublishedByBadge({ user }) {
  if (!user) return null;

  const displayName = user.firstName || user.username || "Admin";

  const avatarSrc = user.picture
    ? `${configuration.cdnFront}/${user.picture}`
    : undefined;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <UserAvatar src={avatarSrc} name={displayName} size={28} />
      <Typography variant="body2">{displayName}</Typography>
      <Chip label="Admin" color="primary" variant="outlined" size="small" />
    </Box>
  );
}
